/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/two_factor';
import './common';
import './service/common';
import './service/service';
import '../sms/sms';
import './service/error';
import './encryption';
import '../authz_engines/authz_engines_service';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "multipass": {
        "nested": {
          "external": {
            "nested": {
              "Error": {
                "values": {
                  "NO_ERROR": 0,
                  "INVALID_ALIAS": 1,
                  "BLOCKED_SMS_NUMBER": 2,
                  "TEMPORARY_LOCKOUT": 3,
                  "INVALID_CREDENTIALS": 4,
                  "INVALID_NEW_PASSWORD": 5,
                  "ALIAS_ALREADY_LINKED": 6,
                  "ALIAS_MERGE_FAILED": 7,
                  "REMOVE_TWO_FACTOR_FAILED": 8,
                  "INVALID_SECURITY_ANSWER": 9,
                  "PASSWORD_REUSE": 10,
                  "PASSWORD_COMMON": 11,
                  "PASSWORD_COMPROMISED": 12,
                  "PASSWORD_FAILS_REQUIREMENTS": 19,
                  "ACCOUNT_LOCKED": 13,
                  "PASSWORD_ALREADY_EXISTS": 14,
                  "INELIGIBLE_PARTNER": 15,
                  "ACCOUNT_ALREADY_CLAIMED": 16,
                  "APPLICATION_NOT_ALLOWED": 17,
                  "NEW_SESSION_FAILED": 18,
                  "MERCHANT_INVALID": 20,
                  "PERSON_INVALID": 21,
                  "TWO_FACTOR_STATE_INVALID": 22,
                  "GENERATE_OTP_FAILED": 23,
                  "SECURE_CONTACT_CONFLICT": 24,
                  "SECURE_CONTACT_VERIFICATION_REQUIRED": 25,
                  "SECURE_CONTACT_NOT_FOUND": 26,
                  "SECURE_CONTACT_ALIAS_CONFLICT": 27,
                  "RECOVERY_ATTEMPTS_EXCEEDED": 28,
                  "RECOVERY_DECISION_DECLINED": 29,
                  "DORMANT_ACCOUNT": 30,
                  "RECOVERY_VERIFICATION_REQUIRED": 31,
                  "NOT_FOUND": 32,
                  "CAPTCHA_REQUIRED": 33,
                  "INVALID_INVITATION_ID": 34,
                  "INVITATION_ALREADY_ACCEPTED": 35,
                  "ACCESS_DENIED": 36,
                  "VERIFICATION_CODE_NOT_SENT": 37
                }
              },
              "ChangePasswordRequest": {
                "fields": {
                  "password": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "newPassword": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": "en"
                    }
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "terminateSessions": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ChangePasswordResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "LinkAliasRequest": {
                "fields": {
                  "email": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "verificationCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "merge": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  }
                }
              },
              "LinkAliasResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "VerificationCodeRequest": {
                "fields": {
                  "reason": {
                    "type": "squareup.multipass.external.VerificationCodeRequest.Reason",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": "en"
                    }
                  },
                  "scope": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sendLink": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "subdomain": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "queryParams": {
                    "type": "squareup.multipass.external.VerificationCodeRequest.QueryParams",
                    "id": 8,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "app": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "deliveryMethod": {
                    "type": "squareup.common.twofactor.TwoFactorDeliveryMethod",
                    "id": 11,
                    "rule": "optional",
                    "options": {
                      "default": "SMS"
                    }
                  },
                  "clientMetadata": {
                    "type": "squareup.multipass.external.VerificationCodeRequest.ClientMetadata",
                    "id": 12,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 3
                  },
                  "smsPhone": {
                    "type": "string",
                    "id": 4
                  }
                },
                "nested": {
                  "Reason": {
                    "values": {
                      "NO_REASON": 0,
                      "LOGIN": 1,
                      "RESET_PASSWORD": 2,
                      "LINK_ALIAS": 3,
                      "TWO_FACTOR": 4,
                      "GENERIC_CODE": 5,
                      "VERIFY": 6,
                      "SECURE_CONTACT": 7,
                      "PHONEPANEL": 8
                    }
                  },
                  "QueryParams": {
                    "fields": {
                      "app": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "returnTo": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ClientMetadata": {
                    "fields": {
                      "clientResendAction": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "contact": {
                    "oneof": ["email", "smsPhone"]
                  }
                }
              },
              "VerificationCodeResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "EnrollTwoFactorRequest": {
                "fields": {
                  "twoFactorDetails": {
                    "type": "squareup.multipass.TwoFactorDetails",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "twoFactorEnrollmentSource": {
                    "type": "squareup.multipass.TwoFactorEnrollmentSource",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": "en"
                    }
                  }
                }
              },
              "EnrollTwoFactorResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "complete": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "twoFactorDetails": {
                    "type": "squareup.multipass.TwoFactorDetails",
                    "id": 3,
                    "rule": "optional"
                  },
                  "shouldPromptForSecureContactEnrollment": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ListTwoFactorRequest": {
                "fields": {
                  "twoFactorVerificationSource": {
                    "type": "squareup.multipass.TwoFactorVerificationSourceScope.TwoFactorVerificationSource",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListTwoFactorResponse": {
                "fields": {
                  "twoFactorDetails": {
                    "type": "squareup.multipass.TwoFactorDetails",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "canDisablePersonalRequirement": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "trustedDeviceTokenAgeIncrease": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "trustedDeviceOptInDefault": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "LogoutAllRequest": {
                "fields": {
                  "excludeCurrentSession": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "LogoutAllResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RemoveTwoFactorRequest": {
                "fields": {
                  "twoFactorDetails": {
                    "type": "squareup.multipass.TwoFactorDetails",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RemoveTwoFactorResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdateMerchantTwoFactorRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "twoFactorState": {
                    "type": "squareup.common.twofactor.TwoFactorState",
                    "id": 2,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateMerchantTwoFactorResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpdatePersonTwoFactorRequest": {
                "fields": {
                  "twoFactorState": {
                    "type": "squareup.common.twofactor.PersonTwoFactorStateScope.PersonTwoFactorState",
                    "id": 1,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdatePersonTwoFactorResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpgradeSessionTwoFactorRequest": {
                "fields": {
                  "twoFactorDetails": {
                    "type": "squareup.multipass.TwoFactorDetails",
                    "id": 1,
                    "rule": "optional"
                  },
                  "twoFactorVerificationSource": {
                    "type": "squareup.multipass.TwoFactorVerificationSourceScope.TwoFactorVerificationSource",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpgradeSessionTwoFactorResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "twoFactorDetails": {
                    "type": "squareup.multipass.TwoFactorDetails",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpgradeSessionMultipleFactorsRequest": {
                "fields": {
                  "twoFactorDetails": {
                    "type": "squareup.multipass.TwoFactorDetails",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "password": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "twoFactorVerificationSource": {
                    "type": "squareup.multipass.TwoFactorVerificationSourceScope.TwoFactorVerificationSource",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpgradeSessionMultipleFactorsResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ResetPasswordSendCodeRequest": {
                "fields": {
                  "locale": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": "en"
                    }
                  },
                  "queryParams": {
                    "type": "squareup.multipass.ResetPasswordLinkQueryParams",
                    "id": 4,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 1
                  },
                  "personToken": {
                    "type": "string",
                    "id": 3
                  },
                  "phone": {
                    "type": "string",
                    "id": 6
                  }
                },
                "nested": {
                  "alias": {
                    "oneof": ["email", "personToken", "phone"]
                  }
                }
              },
              "ResetPasswordSendCodeResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ResetPasswordVerifyCodeRequest": {
                "fields": {
                  "verificationCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "securityAnswer": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 1
                  },
                  "personToken": {
                    "type": "string",
                    "id": 3
                  },
                  "phone": {
                    "type": "string",
                    "id": 5
                  }
                },
                "nested": {
                  "alias": {
                    "oneof": ["email", "personToken", "phone"]
                  }
                }
              },
              "ResetPasswordVerifyCodeResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "securityQuestion": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ResetPasswordChangePasswordRequest": {
                "fields": {
                  "verificationCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "securityAnswer": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "newPassword": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": "en"
                    }
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "deviceDetails": {
                    "type": "squareup.multipass.service.DeviceDetails",
                    "id": 8,
                    "rule": "optional"
                  },
                  "app": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 1
                  },
                  "personToken": {
                    "type": "string",
                    "id": 5
                  },
                  "phone": {
                    "type": "string",
                    "id": 10
                  }
                },
                "nested": {
                  "alias": {
                    "oneof": ["email", "personToken", "phone"]
                  }
                }
              },
              "ResetPasswordChangePasswordResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sessionId": {
                    "type": "squareup.multipass.service.ClientSessionToken",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SetPasswordRequest": {
                "fields": {
                  "newPassword": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "verificationCode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": "en"
                    }
                  },
                  "email": {
                    "type": "string",
                    "id": 1
                  },
                  "personToken": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "alias": {
                    "oneof": ["email", "personToken"]
                  }
                }
              },
              "SetPasswordResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sessionId": {
                    "type": "squareup.multipass.service.ClientSessionToken",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ClaimAccountSendCodeRequest": {
                "fields": {
                  "personToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": "en"
                    }
                  },
                  "queryParams": {
                    "type": "squareup.multipass.external.ClaimAccountSendCodeRequest.QueryParams",
                    "id": 3,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "QueryParams": {
                    "fields": {
                      "returnTo": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ClaimAccountSendCodeResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "VerifyAliasRequest": {
                "fields": {
                  "app": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "verificationCode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 1
                  },
                  "smsPhone": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "alias": {
                    "oneof": ["email", "smsPhone"]
                  }
                }
              },
              "VerifyAliasResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "BrowserHookRequest": {
                "fields": {
                  "app": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "squareup.multipass.external.BrowserHookRequest.Reason",
                    "id": 2,
                    "rule": "optional"
                  },
                  "encryptedParams": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "verificationCode": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "maxTwoFactorMinutes": {
                    "type": "int32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "returnTo": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "invitationId": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Reason": {
                    "values": {
                      "NO_REASON": 0,
                      "SIGN_IN": 1,
                      "CLAIM_ACCOUNT": 2,
                      "RESET_PASSWORD_VERIFY_CODE": 3,
                      "RESET_PASSWORD_SEND_CODE": 4,
                      "SEND_VERIFICATION_CODE": 5,
                      "VERIFY_ALIAS": 6,
                      "ADVANCED_TWO_FACTOR_EMAIL_VERIFY": 7,
                      "SELF_SERVE_RECOVERY": 8,
                      "INVITATION_ACCEPTANCE": 9
                    }
                  }
                }
              },
              "BrowserHookResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "redirectUri": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "decryptedParams": {
                    "type": "squareup.multipass.external.BrowserHookDecryptedParams",
                    "id": 3,
                    "rule": "optional"
                  },
                  "twoFactorProvidedTimestamp": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "requiresTwoFactor": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "kasadaLoginDomainEnabled": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "cdpHeartbeatIntervalSeconds": {
                    "type": "int64",
                    "id": 7,
                    "rule": "optional"
                  },
                  "proofOfWorkNonce": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "BrowserHookDecryptedParams": {
                "fields": {
                  "unitName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "smsPhone": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "username": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "personToken": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "EnrollSecureContactRequest": {
                "fields": {
                  "secureContactDetails": {
                    "type": "squareup.multipass.SecureContactDetails",
                    "id": 1,
                    "rule": "optional"
                  },
                  "verificationCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "secureContactEnrollmentSource": {
                    "type": "squareup.multipass.service.EnrollSecureContactRequest.SecureContactEnrollmentSource",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "EnrollSecureContactResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "secureContactDetails": {
                    "type": "squareup.multipass.SecureContactDetails",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "ListSecureContactRequest": {
                "fields": {}
              },
              "ListSecureContactResponse": {
                "fields": {
                  "secureContactDetails": {
                    "type": "squareup.multipass.SecureContactDetails",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "UpdateSecureContactRequest": {
                "fields": {
                  "oldSecureContactDetails": {
                    "type": "squareup.multipass.SecureContactDetails",
                    "id": 1,
                    "rule": "optional"
                  },
                  "secureContactDetails": {
                    "type": "squareup.multipass.SecureContactDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "verificationCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateSecureContactResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "secureContactDetails": {
                    "type": "squareup.multipass.SecureContactDetails",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "VerifySecureContactRequest": {
                "fields": {
                  "secureContactDetails": {
                    "type": "squareup.multipass.SecureContactDetails",
                    "id": 1,
                    "rule": "optional"
                  },
                  "verificationCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "VerifySecureContactResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListTwoFactorRequirementsRequest": {
                "fields": {}
              },
              "ListTwoFactorRequirementsResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "requirement": {
                    "type": "squareup.multipass.external.ListTwoFactorRequirementsResponse.Requirement",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "merchantRequirement": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Requirement": {
                    "fields": {
                      "twoFactorReason": {
                        "type": "squareup.common.twofactor.TwoFactorReasonScope.TwoFactorReason",
                        "id": 1,
                        "rule": "optional"
                      },
                      "twoFactorState": {
                        "type": "squareup.common.twofactor.PersonTwoFactorStateScope.PersonTwoFactorState",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ListRecoveryDetailsRequest": {
                "fields": {
                  "reason": {
                    "type": "squareup.multipass.RecoveryReasonScope.RecoveryReason",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListRecoveryDetailsResponse": {
                "fields": {
                  "recoveryDetails": {
                    "type": "squareup.multipass.RecoveryDetails",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "canUseActivationPhone": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "canUseNewPhone": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "canUseIdentityVerificationPhone": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "VerifyRecoveryDetailRequest": {
                "fields": {
                  "method": {
                    "type": "squareup.multipass.RecoveryMethodScope.RecoveryMethod",
                    "id": 1,
                    "rule": "optional"
                  },
                  "phone": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "verificationCode": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": "en"
                    }
                  },
                  "reason": {
                    "type": "squareup.multipass.RecoveryReasonScope.RecoveryReason",
                    "id": 5,
                    "rule": "optional"
                  },
                  "deliveryMethod": {
                    "type": "squareup.common.twofactor.TwoFactorDeliveryMethod",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": "SMS"
                    }
                  }
                }
              },
              "VerifyRecoveryDetailResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListLaunchpadItemsRequest": {
                "fields": {
                  "app": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "returnTo": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ListLaunchpadItemsResponse": {
                "fields": {
                  "merchantItems": {
                    "type": "squareup.multipass.LaunchpadMerchantItem",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "serviceItems": {
                    "type": "squareup.multipass.LaunchpadServiceItem",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "CreateMandatoryTwoFactorExceptionRequest": {
                "fields": {
                  "requestedDurationDays": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CreateMandatoryTwoFactorExceptionResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "AdvancedEnrollTwoFactorSendLinkRequest": {
                "fields": {
                  "email": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": "en"
                    }
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "AdvancedEnrollTwoFactorSendLinkResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetGeneralSettingsRequest": {
                "fields": {
                  "app": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetGeneralSettingsResponse": {
                "fields": {
                  "useAppSubdomain": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "TwoFactorPromoCohortRequest": {
                "fields": {}
              },
              "TwoFactorPromoCohortResponse": {
                "fields": {
                  "result": {
                    "type": "squareup.multipass.service.TwoFactorPromoCohortResponse.CohortType",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CheckLoginRequirementsRequest": {
                "fields": {
                  "app": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": "en"
                    }
                  },
                  "idempotenceKey": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "deviceType": {
                    "type": "squareup.multipass.Device.Type",
                    "id": 6,
                    "rule": "optional"
                  },
                  "captchaResponse": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "captchaType": {
                    "type": "squareup.multipass.CaptchaTypeScope.CaptchaType",
                    "id": 8,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 1
                  },
                  "phone": {
                    "type": "string",
                    "id": 2
                  },
                  "inferable": {
                    "type": "string",
                    "id": 9
                  }
                },
                "nested": {
                  "alias": {
                    "oneof": ["email", "phone", "inferable"]
                  }
                }
              },
              "AliasInferenceDecision": {
                "values": {
                  "AMBIGUOUS": 0,
                  "EMAIL": 1,
                  "PHONE": 2
                }
              },
              "CheckLoginRequirementsResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "nextLoginStep": {
                    "type": "squareup.multipass.external.CheckLoginRequirementsResponse.Step",
                    "id": 2,
                    "rule": "optional"
                  },
                  "captchaApiKey": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "inferredAliasType": {
                    "type": "squareup.multipass.external.AliasInferenceDecision",
                    "id": 4,
                    "rule": "optional"
                  },
                  "authenticationId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "publicKeyCredentialRequestOptions": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Step": {
                    "values": {
                      "NO_STEP": 0,
                      "REQUEST_PASSWORD": 1,
                      "VALIDATE_OTP": 2
                    }
                  }
                }
              },
              "ManagePhoneDetailRequest": {
                "fields": {
                  "phone": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "action": {
                    "type": "squareup.sms.ManagePhoneNumberRequest.PhoneNumberAction",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ManagePhoneDetailResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "AcceptInvitationRequest": {
                "fields": {
                  "invitationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "email": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "password": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "AcceptInvitationResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetPasskeyChallengeRequest": {
                "fields": {
                  "userVerification": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": "preferred"
                    }
                  }
                }
              },
              "GetPasskeyChallengeResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "authenticationId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "publicKeyCredentialRequestOptions": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ListPasskeysRequest": {
                "fields": {}
              },
              "ListPasskeysResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.service.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "passkeys": {
                    "type": "squareup.multipass.PasskeyCredential",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "UpdatePasskeyRequest": {
                "fields": {
                  "credentialId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdatePasskeyResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "passkey": {
                    "type": "squareup.multipass.PasskeyCredential",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetObfuscatedAccountInformationRequest": {
                "fields": {}
              },
              "GetObfuscatedAccountInformationResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "obfuscatedPhoneNumber": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CompleteLoginRequest": {
                "fields": {}
              },
              "CompleteLoginResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.multipass.external.Error",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "MultipassExternalService": {
                "methods": {
                  "ChangePassword": {
                    "requestType": "squareup.multipass.external.ChangePasswordRequest",
                    "responseType": "squareup.multipass.external.ChangePasswordResponse"
                  },
                  "LinkAlias": {
                    "requestType": "squareup.multipass.external.LinkAliasRequest",
                    "responseType": "squareup.multipass.external.LinkAliasResponse"
                  },
                  "RemoveTwoFactor": {
                    "requestType": "squareup.multipass.external.RemoveTwoFactorRequest",
                    "responseType": "squareup.multipass.external.RemoveTwoFactorResponse"
                  },
                  "SendVerificationCode": {
                    "requestType": "squareup.multipass.external.VerificationCodeRequest",
                    "responseType": "squareup.multipass.external.VerificationCodeResponse"
                  },
                  "ClaimAccountSetPassword": {
                    "requestType": "squareup.multipass.external.SetPasswordRequest",
                    "responseType": "squareup.multipass.external.SetPasswordResponse"
                  },
                  "CreateOtk": {
                    "requestType": "squareup.multipass.service.CreateOtkRequest",
                    "responseType": "squareup.multipass.service.CreateOtkResponse"
                  },
                  "DecryptEmail": {
                    "requestType": "squareup.multipass.service.DecryptEmailRequest",
                    "responseType": "squareup.multipass.service.DecryptEmailResponse"
                  },
                  "EnrollTwoFactor": {
                    "requestType": "squareup.multipass.external.EnrollTwoFactorRequest",
                    "responseType": "squareup.multipass.external.EnrollTwoFactorResponse"
                  },
                  "ListTwoFactor": {
                    "requestType": "squareup.multipass.external.ListTwoFactorRequest",
                    "responseType": "squareup.multipass.external.ListTwoFactorResponse"
                  },
                  "ListTwoFactorRequirements": {
                    "requestType": "squareup.multipass.external.ListTwoFactorRequirementsRequest",
                    "responseType": "squareup.multipass.external.ListTwoFactorRequirementsResponse"
                  },
                  "UpdateMerchantTwoFactor": {
                    "requestType": "squareup.multipass.external.UpdateMerchantTwoFactorRequest",
                    "responseType": "squareup.multipass.external.UpdateMerchantTwoFactorResponse"
                  },
                  "UpdatePersonTwoFactor": {
                    "requestType": "squareup.multipass.external.UpdatePersonTwoFactorRequest",
                    "responseType": "squareup.multipass.external.UpdatePersonTwoFactorResponse"
                  },
                  "UpgradeSessionTwoFactor": {
                    "requestType": "squareup.multipass.external.UpgradeSessionTwoFactorRequest",
                    "responseType": "squareup.multipass.external.UpgradeSessionTwoFactorResponse"
                  },
                  "UpgradeSessionMultipleFactors": {
                    "requestType": "squareup.multipass.external.UpgradeSessionMultipleFactorsRequest",
                    "responseType": "squareup.multipass.external.UpgradeSessionMultipleFactorsResponse"
                  },
                  "ResetPasswordSendCode": {
                    "requestType": "squareup.multipass.external.ResetPasswordSendCodeRequest",
                    "responseType": "squareup.multipass.external.ResetPasswordSendCodeResponse"
                  },
                  "ResetPasswordVerifyCode": {
                    "requestType": "squareup.multipass.external.ResetPasswordVerifyCodeRequest",
                    "responseType": "squareup.multipass.external.ResetPasswordVerifyCodeResponse"
                  },
                  "ResetPasswordChangePassword": {
                    "requestType": "squareup.multipass.external.ResetPasswordChangePasswordRequest",
                    "responseType": "squareup.multipass.external.ResetPasswordChangePasswordResponse"
                  },
                  "ClaimAccountSendCode": {
                    "requestType": "squareup.multipass.external.ClaimAccountSendCodeRequest",
                    "responseType": "squareup.multipass.external.ClaimAccountSendCodeResponse"
                  },
                  "VerifyAlias": {
                    "requestType": "squareup.multipass.external.VerifyAliasRequest",
                    "responseType": "squareup.multipass.external.VerifyAliasResponse"
                  },
                  "ExternalDeleteTwoFactorDetails": {
                    "requestType": "squareup.multipass.service.DeleteTwoFactorDetailsRequest",
                    "responseType": "squareup.multipass.service.DeleteTwoFactorDetailsResponse"
                  },
                  "CheckPassword": {
                    "requestType": "squareup.multipass.service.CheckPasswordRequest",
                    "responseType": "squareup.multipass.service.CheckPasswordResponse"
                  },
                  "RedeemAuthorizationCode": {
                    "requestType": "squareup.multipass.service.RedeemAuthorizationCodeRequest",
                    "responseType": "squareup.multipass.service.RedeemAuthorizationCodeResponse"
                  },
                  "CreateIdentityTokenFromSession": {
                    "requestType": "squareup.multipass.service.CreateIdentityTokenFromSessionRequest",
                    "responseType": "squareup.multipass.service.CreateIdentityTokenFromSessionResponse"
                  },
                  "BrowserHook": {
                    "requestType": "squareup.multipass.external.BrowserHookRequest",
                    "responseType": "squareup.multipass.external.BrowserHookResponse"
                  },
                  "EnrollSecureContact": {
                    "requestType": "squareup.multipass.external.EnrollSecureContactRequest",
                    "responseType": "squareup.multipass.external.EnrollSecureContactResponse"
                  },
                  "ListSecureContact": {
                    "requestType": "squareup.multipass.external.ListSecureContactRequest",
                    "responseType": "squareup.multipass.external.ListSecureContactResponse"
                  },
                  "UpdateSecureContact": {
                    "requestType": "squareup.multipass.external.UpdateSecureContactRequest",
                    "responseType": "squareup.multipass.external.UpdateSecureContactResponse"
                  },
                  "VerifySecureContact": {
                    "requestType": "squareup.multipass.external.VerifySecureContactRequest",
                    "responseType": "squareup.multipass.external.VerifySecureContactResponse"
                  },
                  "ListRecoveryDetails": {
                    "requestType": "squareup.multipass.external.ListRecoveryDetailsRequest",
                    "responseType": "squareup.multipass.external.ListRecoveryDetailsResponse"
                  },
                  "VerifyRecoveryDetail": {
                    "requestType": "squareup.multipass.external.VerifyRecoveryDetailRequest",
                    "responseType": "squareup.multipass.external.VerifyRecoveryDetailResponse"
                  },
                  "ListLaunchpadItems": {
                    "requestType": "squareup.multipass.external.ListLaunchpadItemsRequest",
                    "responseType": "squareup.multipass.external.ListLaunchpadItemsResponse"
                  },
                  "LogoutAll": {
                    "requestType": "squareup.multipass.external.LogoutAllRequest",
                    "responseType": "squareup.multipass.external.LogoutAllResponse"
                  },
                  "ListActiveSessions": {
                    "requestType": "squareup.multipass.service.ListActiveSessionsRequest",
                    "responseType": "squareup.multipass.service.ListActiveSessionsResponse"
                  },
                  "CreateMandatoryTwoFactorException": {
                    "requestType": "squareup.multipass.external.CreateMandatoryTwoFactorExceptionRequest",
                    "responseType": "squareup.multipass.external.CreateMandatoryTwoFactorExceptionResponse"
                  },
                  "AdvancedEnrollTwoFactorSendLink": {
                    "requestType": "squareup.multipass.external.AdvancedEnrollTwoFactorSendLinkRequest",
                    "responseType": "squareup.multipass.external.AdvancedEnrollTwoFactorSendLinkResponse"
                  },
                  "GetGeneralSettings": {
                    "requestType": "squareup.multipass.external.GetGeneralSettingsRequest",
                    "responseType": "squareup.multipass.external.GetGeneralSettingsResponse"
                  },
                  "GetTwoFactorPromoCohort": {
                    "requestType": "squareup.multipass.external.TwoFactorPromoCohortRequest",
                    "responseType": "squareup.multipass.external.TwoFactorPromoCohortResponse"
                  },
                  "CheckLoginRequirements": {
                    "requestType": "squareup.multipass.external.CheckLoginRequirementsRequest",
                    "responseType": "squareup.multipass.external.CheckLoginRequirementsResponse"
                  },
                  "ManagePhoneDetail": {
                    "requestType": "squareup.multipass.external.ManagePhoneDetailRequest",
                    "responseType": "squareup.multipass.external.ManagePhoneDetailResponse"
                  },
                  "AcceptInvitation": {
                    "requestType": "squareup.multipass.external.AcceptInvitationRequest",
                    "responseType": "squareup.multipass.external.AcceptInvitationResponse"
                  },
                  "GetPasskeyChallenge": {
                    "requestType": "squareup.multipass.external.GetPasskeyChallengeRequest",
                    "responseType": "squareup.multipass.external.GetPasskeyChallengeResponse"
                  },
                  "ListPasskeys": {
                    "requestType": "squareup.multipass.external.ListPasskeysRequest",
                    "responseType": "squareup.multipass.external.ListPasskeysResponse"
                  },
                  "UpdatePasskey": {
                    "requestType": "squareup.multipass.external.UpdatePasskeyRequest",
                    "responseType": "squareup.multipass.external.UpdatePasskeyResponse"
                  },
                  "AuthzEnginesAllow": {
                    "requestType": "squareup.authz_engines.AllowRequest",
                    "responseType": "squareup.authz_engines.AllowResponse"
                  },
                  "GetObfuscatedAccountInformation": {
                    "requestType": "squareup.multipass.external.GetObfuscatedAccountInformationRequest",
                    "responseType": "squareup.multipass.external.GetObfuscatedAccountInformationResponse"
                  },
                  "CompleteLogin": {
                    "requestType": "squareup.multipass.external.CompleteLoginRequest",
                    "responseType": "squareup.multipass.external.CompleteLoginResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.Error && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ChangePasswordRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ChangePasswordResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.LinkAliasRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.LinkAliasResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.VerificationCodeRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.VerificationCodeRequest?.nested?.Reason && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.VerificationCodeRequest?.nested?.QueryParams && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.VerificationCodeRequest?.nested?.ClientMetadata && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.VerificationCodeResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.EnrollTwoFactorRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.EnrollTwoFactorResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListTwoFactorRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListTwoFactorResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.LogoutAllRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.LogoutAllResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.RemoveTwoFactorRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.RemoveTwoFactorResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpdateMerchantTwoFactorRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpdateMerchantTwoFactorResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpdatePersonTwoFactorRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpdatePersonTwoFactorResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpgradeSessionTwoFactorRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpgradeSessionTwoFactorResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpgradeSessionMultipleFactorsRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpgradeSessionMultipleFactorsResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ResetPasswordSendCodeRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ResetPasswordSendCodeResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ResetPasswordVerifyCodeRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ResetPasswordVerifyCodeResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ResetPasswordChangePasswordRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ResetPasswordChangePasswordResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.SetPasswordRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.SetPasswordResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ClaimAccountSendCodeRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ClaimAccountSendCodeRequest?.nested?.QueryParams && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ClaimAccountSendCodeResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.VerifyAliasRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.VerifyAliasResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.BrowserHookRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.BrowserHookRequest?.nested?.Reason && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.BrowserHookResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.BrowserHookDecryptedParams && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.EnrollSecureContactRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.EnrollSecureContactResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListSecureContactRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListSecureContactResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpdateSecureContactRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpdateSecureContactResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.VerifySecureContactRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.VerifySecureContactResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListTwoFactorRequirementsRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListTwoFactorRequirementsResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListTwoFactorRequirementsResponse?.nested?.Requirement && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListRecoveryDetailsRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListRecoveryDetailsResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.VerifyRecoveryDetailRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.VerifyRecoveryDetailResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListLaunchpadItemsRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListLaunchpadItemsResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.CreateMandatoryTwoFactorExceptionRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.CreateMandatoryTwoFactorExceptionResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.AdvancedEnrollTwoFactorSendLinkRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.AdvancedEnrollTwoFactorSendLinkResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.GetGeneralSettingsRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.GetGeneralSettingsResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.TwoFactorPromoCohortRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.TwoFactorPromoCohortResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.CheckLoginRequirementsRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.AliasInferenceDecision && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.CheckLoginRequirementsResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.CheckLoginRequirementsResponse?.nested?.Step && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ManagePhoneDetailRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ManagePhoneDetailResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.AcceptInvitationRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.AcceptInvitationResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.GetPasskeyChallengeRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.GetPasskeyChallengeResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListPasskeysRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.ListPasskeysResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpdatePasskeyRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.UpdatePasskeyResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.GetObfuscatedAccountInformationRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.GetObfuscatedAccountInformationResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.CompleteLoginRequest && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.CompleteLoginResponse && !$root.nested?.squareup?.nested?.multipass?.nested?.external?.nested?.MultipassExternalService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Error @ squareup/multipass/external.proto at 23:1
 */
export const Error = $root.lookupEnum('squareup.multipass.external.Error').values;
/**
 * A request to change the logged in user's password.
 *
 * SOURCE ChangePasswordRequest @ squareup/multipass/external.proto at 148:1
 */
export const ChangePasswordRequest = $root.lookupType('squareup.multipass.external.ChangePasswordRequest');
fixType(ChangePasswordRequest);
Builder.createAndAttachToType(ChangePasswordRequest);
/**
 * SOURCE ChangePasswordResponse @ squareup/multipass/external.proto at 168:1
 */
export const ChangePasswordResponse = $root.lookupType('squareup.multipass.external.ChangePasswordResponse');
fixType(ChangePasswordResponse);
Builder.createAndAttachToType(ChangePasswordResponse);
/**
 * A request to link a new alias to the currently logged in person.
 *
 * SOURCE LinkAliasRequest @ squareup/multipass/external.proto at 199:1
 */
export const LinkAliasRequest = $root.lookupType('squareup.multipass.external.LinkAliasRequest');
fixType(LinkAliasRequest);
Builder.createAndAttachToType(LinkAliasRequest);
/**
 * SOURCE LinkAliasResponse @ squareup/multipass/external.proto at 213:1
 */
export const LinkAliasResponse = $root.lookupType('squareup.multipass.external.LinkAliasResponse');
fixType(LinkAliasResponse);
Builder.createAndAttachToType(LinkAliasResponse);
/**
 * Request a verification code be sent to the person.  Verification codes are required for
 * several operations.  The general flow is to first request a verification code for a specific
 * purpose, then once the user enters the code, perform the actual verified request.
 *
 * Exactly one contact method must be supplied.
 *
 * SOURCE VerificationCodeRequest @ squareup/multipass/external.proto at 225:1
 */
export const VerificationCodeRequest = $root.lookupType('squareup.multipass.external.VerificationCodeRequest');
fixType(VerificationCodeRequest);
Builder.createAndAttachToType(VerificationCodeRequest);
/**
 * SOURCE Reason @ squareup/multipass/external.proto at 273:3
 */
VerificationCodeRequest.Reason = $root.lookupEnum('squareup.multipass.external.VerificationCodeRequest.Reason').values;
/**
 * SOURCE QueryParams @ squareup/multipass/external.proto at 297:3
 */
VerificationCodeRequest.QueryParams = $root.lookupType('squareup.multipass.external.VerificationCodeRequest.QueryParams');
fixType(VerificationCodeRequest.QueryParams);
Builder.createAndAttachToType(VerificationCodeRequest.QueryParams);
/**
 * SOURCE ClientMetadata @ squareup/multipass/external.proto at 304:3
 */
VerificationCodeRequest.ClientMetadata = $root.lookupType('squareup.multipass.external.VerificationCodeRequest.ClientMetadata');
fixType(VerificationCodeRequest.ClientMetadata);
Builder.createAndAttachToType(VerificationCodeRequest.ClientMetadata);
/**
 * SOURCE VerificationCodeResponse @ squareup/multipass/external.proto at 310:1
 */
export const VerificationCodeResponse = $root.lookupType('squareup.multipass.external.VerificationCodeResponse');
fixType(VerificationCodeResponse);
Builder.createAndAttachToType(VerificationCodeResponse);
/**
 * Add a 2FA method for the LoggedInUser.
 *
 * SOURCE EnrollTwoFactorRequest @ squareup/multipass/external.proto at 316:1
 */
export const EnrollTwoFactorRequest = $root.lookupType('squareup.multipass.external.EnrollTwoFactorRequest');
fixType(EnrollTwoFactorRequest);
Builder.createAndAttachToType(EnrollTwoFactorRequest);
/**
 * SOURCE EnrollTwoFactorResponse @ squareup/multipass/external.proto at 330:1
 */
export const EnrollTwoFactorResponse = $root.lookupType('squareup.multipass.external.EnrollTwoFactorResponse');
fixType(EnrollTwoFactorResponse);
Builder.createAndAttachToType(EnrollTwoFactorResponse);
/**
 * TODO(yskhoo): switch to common squareup.multipass.ListTwoFactorRequest
 *
 * SOURCE ListTwoFactorRequest @ squareup/multipass/external.proto at 347:1
 */
export const ListTwoFactorRequest = $root.lookupType('squareup.multipass.external.ListTwoFactorRequest');
fixType(ListTwoFactorRequest);
Builder.createAndAttachToType(ListTwoFactorRequest);
/**
 * TODO(yskhoo): switch to common squareup.multipass.ListTwoFactorResponse
 * TODO(bt,jat): Before launch, check with infosec about sending phone number back to the client.
 *
 * SOURCE ListTwoFactorResponse @ squareup/multipass/external.proto at 354:1
 */
export const ListTwoFactorResponse = $root.lookupType('squareup.multipass.external.ListTwoFactorResponse');
fixType(ListTwoFactorResponse);
Builder.createAndAttachToType(ListTwoFactorResponse);
/**
 * SOURCE LogoutAllRequest @ squareup/multipass/external.proto at 368:1
 */
export const LogoutAllRequest = $root.lookupType('squareup.multipass.external.LogoutAllRequest');
fixType(LogoutAllRequest);
Builder.createAndAttachToType(LogoutAllRequest);
/**
 * SOURCE LogoutAllResponse @ squareup/multipass/external.proto at 373:1
 */
export const LogoutAllResponse = $root.lookupType('squareup.multipass.external.LogoutAllResponse');
fixType(LogoutAllResponse);
Builder.createAndAttachToType(LogoutAllResponse);
/**
 * A request to remove a 2FA method for the currently logged in person.
 *
 * SOURCE RemoveTwoFactorRequest @ squareup/multipass/external.proto at 381:1
 */
export const RemoveTwoFactorRequest = $root.lookupType('squareup.multipass.external.RemoveTwoFactorRequest');
fixType(RemoveTwoFactorRequest);
Builder.createAndAttachToType(RemoveTwoFactorRequest);
/**
 * SOURCE RemoveTwoFactorResponse @ squareup/multipass/external.proto at 386:1
 */
export const RemoveTwoFactorResponse = $root.lookupType('squareup.multipass.external.RemoveTwoFactorResponse');
fixType(RemoveTwoFactorResponse);
Builder.createAndAttachToType(RemoveTwoFactorResponse);
/**
 * Update the two factor requirements for a merchant.
 *
 * SOURCE UpdateMerchantTwoFactorRequest @ squareup/multipass/external.proto at 392:1
 */
export const UpdateMerchantTwoFactorRequest = $root.lookupType('squareup.multipass.external.UpdateMerchantTwoFactorRequest');
fixType(UpdateMerchantTwoFactorRequest);
Builder.createAndAttachToType(UpdateMerchantTwoFactorRequest);
/**
 * SOURCE UpdateMerchantTwoFactorResponse @ squareup/multipass/external.proto at 403:1
 */
export const UpdateMerchantTwoFactorResponse = $root.lookupType('squareup.multipass.external.UpdateMerchantTwoFactorResponse');
fixType(UpdateMerchantTwoFactorResponse);
Builder.createAndAttachToType(UpdateMerchantTwoFactorResponse);
/**
 * Update the two factor requirements for the current person.
 *
 * SOURCE UpdatePersonTwoFactorRequest @ squareup/multipass/external.proto at 409:1
 */
export const UpdatePersonTwoFactorRequest = $root.lookupType('squareup.multipass.external.UpdatePersonTwoFactorRequest');
fixType(UpdatePersonTwoFactorRequest);
Builder.createAndAttachToType(UpdatePersonTwoFactorRequest);
/**
 * SOURCE UpdatePersonTwoFactorResponse @ squareup/multipass/external.proto at 417:1
 */
export const UpdatePersonTwoFactorResponse = $root.lookupType('squareup.multipass.external.UpdatePersonTwoFactorResponse');
fixType(UpdatePersonTwoFactorResponse);
Builder.createAndAttachToType(UpdatePersonTwoFactorResponse);
/**
 * Upgrade the current session to a 2FA-protected session.
 *
 * SOURCE UpgradeSessionTwoFactorRequest @ squareup/multipass/external.proto at 423:1
 */
export const UpgradeSessionTwoFactorRequest = $root.lookupType('squareup.multipass.external.UpgradeSessionTwoFactorRequest');
fixType(UpgradeSessionTwoFactorRequest);
Builder.createAndAttachToType(UpgradeSessionTwoFactorRequest);
/**
 * SOURCE UpgradeSessionTwoFactorResponse @ squareup/multipass/external.proto at 431:1
 */
export const UpgradeSessionTwoFactorResponse = $root.lookupType('squareup.multipass.external.UpgradeSessionTwoFactorResponse');
fixType(UpgradeSessionTwoFactorResponse);
Builder.createAndAttachToType(UpgradeSessionTwoFactorResponse);
/**
 * Upgrade the current session to a 2FA-protected session compliant with SCA (and,
 * potentially later, other similar) regulations. TL;DR is that the user must complete 2/3 of
 * knowledge-, inherence-, or possession-based authentication which can include biometrics,
 * SMS/voice/authenticator, credential, etc checks.
 *
 * SOURCE UpgradeSessionMultipleFactorsRequest @ squareup/multipass/external.proto at 444:1
 */
export const UpgradeSessionMultipleFactorsRequest = $root.lookupType('squareup.multipass.external.UpgradeSessionMultipleFactorsRequest');
fixType(UpgradeSessionMultipleFactorsRequest);
Builder.createAndAttachToType(UpgradeSessionMultipleFactorsRequest);
/**
 * SOURCE UpgradeSessionMultipleFactorsResponse @ squareup/multipass/external.proto at 458:1
 */
export const UpgradeSessionMultipleFactorsResponse = $root.lookupType('squareup.multipass.external.UpgradeSessionMultipleFactorsResponse');
fixType(UpgradeSessionMultipleFactorsResponse);
Builder.createAndAttachToType(UpgradeSessionMultipleFactorsResponse);
/**
 * SOURCE ResetPasswordSendCodeRequest @ squareup/multipass/external.proto at 462:1
 */
export const ResetPasswordSendCodeRequest = $root.lookupType('squareup.multipass.external.ResetPasswordSendCodeRequest');
fixType(ResetPasswordSendCodeRequest);
Builder.createAndAttachToType(ResetPasswordSendCodeRequest);
/**
 * SOURCE ResetPasswordSendCodeResponse @ squareup/multipass/external.proto at 488:1
 */
export const ResetPasswordSendCodeResponse = $root.lookupType('squareup.multipass.external.ResetPasswordSendCodeResponse');
fixType(ResetPasswordSendCodeResponse);
Builder.createAndAttachToType(ResetPasswordSendCodeResponse);
/**
 * SOURCE ResetPasswordVerifyCodeRequest @ squareup/multipass/external.proto at 493:1
 */
export const ResetPasswordVerifyCodeRequest = $root.lookupType('squareup.multipass.external.ResetPasswordVerifyCodeRequest');
fixType(ResetPasswordVerifyCodeRequest);
Builder.createAndAttachToType(ResetPasswordVerifyCodeRequest);
/**
 * SOURCE ResetPasswordVerifyCodeResponse @ squareup/multipass/external.proto at 514:1
 */
export const ResetPasswordVerifyCodeResponse = $root.lookupType('squareup.multipass.external.ResetPasswordVerifyCodeResponse');
fixType(ResetPasswordVerifyCodeResponse);
Builder.createAndAttachToType(ResetPasswordVerifyCodeResponse);
/**
 * SOURCE ResetPasswordChangePasswordRequest @ squareup/multipass/external.proto at 524:1
 */
export const ResetPasswordChangePasswordRequest = $root.lookupType('squareup.multipass.external.ResetPasswordChangePasswordRequest');
fixType(ResetPasswordChangePasswordRequest);
Builder.createAndAttachToType(ResetPasswordChangePasswordRequest);
/**
 * SOURCE ResetPasswordChangePasswordResponse @ squareup/multipass/external.proto at 565:1
 */
export const ResetPasswordChangePasswordResponse = $root.lookupType('squareup.multipass.external.ResetPasswordChangePasswordResponse');
fixType(ResetPasswordChangePasswordResponse);
Builder.createAndAttachToType(ResetPasswordChangePasswordResponse);
/**
 * SOURCE SetPasswordRequest @ squareup/multipass/external.proto at 576:1
 */
export const SetPasswordRequest = $root.lookupType('squareup.multipass.external.SetPasswordRequest');
fixType(SetPasswordRequest);
Builder.createAndAttachToType(SetPasswordRequest);
/**
 * SOURCE SetPasswordResponse @ squareup/multipass/external.proto at 598:1
 */
export const SetPasswordResponse = $root.lookupType('squareup.multipass.external.SetPasswordResponse');
fixType(SetPasswordResponse);
Builder.createAndAttachToType(SetPasswordResponse);
/**
 * SOURCE ClaimAccountSendCodeRequest @ squareup/multipass/external.proto at 628:1
 */
export const ClaimAccountSendCodeRequest = $root.lookupType('squareup.multipass.external.ClaimAccountSendCodeRequest');
fixType(ClaimAccountSendCodeRequest);
Builder.createAndAttachToType(ClaimAccountSendCodeRequest);
/**
 * SOURCE QueryParams @ squareup/multipass/external.proto at 638:3
 */
ClaimAccountSendCodeRequest.QueryParams = $root.lookupType('squareup.multipass.external.ClaimAccountSendCodeRequest.QueryParams');
fixType(ClaimAccountSendCodeRequest.QueryParams);
Builder.createAndAttachToType(ClaimAccountSendCodeRequest.QueryParams);
/**
 * SOURCE ClaimAccountSendCodeResponse @ squareup/multipass/external.proto at 646:1
 */
export const ClaimAccountSendCodeResponse = $root.lookupType('squareup.multipass.external.ClaimAccountSendCodeResponse');
fixType(ClaimAccountSendCodeResponse);
Builder.createAndAttachToType(ClaimAccountSendCodeResponse);
/**
 * SOURCE VerifyAliasRequest @ squareup/multipass/external.proto at 662:1
 */
export const VerifyAliasRequest = $root.lookupType('squareup.multipass.external.VerifyAliasRequest');
fixType(VerifyAliasRequest);
Builder.createAndAttachToType(VerifyAliasRequest);
/**
 * SOURCE VerifyAliasResponse @ squareup/multipass/external.proto at 681:1
 */
export const VerifyAliasResponse = $root.lookupType('squareup.multipass.external.VerifyAliasResponse');
fixType(VerifyAliasResponse);
Builder.createAndAttachToType(VerifyAliasResponse);
/**
 * SOURCE BrowserHookRequest @ squareup/multipass/external.proto at 688:1
 */
export const BrowserHookRequest = $root.lookupType('squareup.multipass.external.BrowserHookRequest');
fixType(BrowserHookRequest);
Builder.createAndAttachToType(BrowserHookRequest);
/**
 * SOURCE Reason @ squareup/multipass/external.proto at 719:3
 */
BrowserHookRequest.Reason = $root.lookupEnum('squareup.multipass.external.BrowserHookRequest.Reason').values;
/**
 * SOURCE BrowserHookResponse @ squareup/multipass/external.proto at 753:1
 */
export const BrowserHookResponse = $root.lookupType('squareup.multipass.external.BrowserHookResponse');
fixType(BrowserHookResponse);
Builder.createAndAttachToType(BrowserHookResponse);
/**
 * SOURCE BrowserHookDecryptedParams @ squareup/multipass/external.proto at 805:1
 */
export const BrowserHookDecryptedParams = $root.lookupType('squareup.multipass.external.BrowserHookDecryptedParams');
fixType(BrowserHookDecryptedParams);
Builder.createAndAttachToType(BrowserHookDecryptedParams);
/**
 * Add a secure contact method for the LoggedInUser.
 *
 * SOURCE EnrollSecureContactRequest @ squareup/multipass/external.proto at 832:1
 */
export const EnrollSecureContactRequest = $root.lookupType('squareup.multipass.external.EnrollSecureContactRequest');
fixType(EnrollSecureContactRequest);
Builder.createAndAttachToType(EnrollSecureContactRequest);
/**
 * SOURCE EnrollSecureContactResponse @ squareup/multipass/external.proto at 843:1
 */
export const EnrollSecureContactResponse = $root.lookupType('squareup.multipass.external.EnrollSecureContactResponse');
fixType(EnrollSecureContactResponse);
Builder.createAndAttachToType(EnrollSecureContactResponse);
/**
 * Lists secure contact methods for the LoggedInUser.
 *
 * SOURCE ListSecureContactRequest @ squareup/multipass/external.proto at 860:1
 */
export const ListSecureContactRequest = $root.lookupType('squareup.multipass.external.ListSecureContactRequest');
fixType(ListSecureContactRequest);
Builder.createAndAttachToType(ListSecureContactRequest);
/**
 * SOURCE ListSecureContactResponse @ squareup/multipass/external.proto at 864:1
 */
export const ListSecureContactResponse = $root.lookupType('squareup.multipass.external.ListSecureContactResponse');
fixType(ListSecureContactResponse);
Builder.createAndAttachToType(ListSecureContactResponse);
/**
 * Updates a secure contact method for the LoggedInUser.
 *
 * SOURCE UpdateSecureContactRequest @ squareup/multipass/external.proto at 870:1
 */
export const UpdateSecureContactRequest = $root.lookupType('squareup.multipass.external.UpdateSecureContactRequest');
fixType(UpdateSecureContactRequest);
Builder.createAndAttachToType(UpdateSecureContactRequest);
/**
 * SOURCE UpdateSecureContactResponse @ squareup/multipass/external.proto at 881:1
 */
export const UpdateSecureContactResponse = $root.lookupType('squareup.multipass.external.UpdateSecureContactResponse');
fixType(UpdateSecureContactResponse);
Builder.createAndAttachToType(UpdateSecureContactResponse);
/**
 * Verifies access to the secure contact method for the LoggedInUser.
 *
 * SOURCE VerifySecureContactRequest @ squareup/multipass/external.proto at 897:1
 */
export const VerifySecureContactRequest = $root.lookupType('squareup.multipass.external.VerifySecureContactRequest');
fixType(VerifySecureContactRequest);
Builder.createAndAttachToType(VerifySecureContactRequest);
/**
 * SOURCE VerifySecureContactResponse @ squareup/multipass/external.proto at 905:1
 */
export const VerifySecureContactResponse = $root.lookupType('squareup.multipass.external.VerifySecureContactResponse');
fixType(VerifySecureContactResponse);
Builder.createAndAttachToType(VerifySecureContactResponse);
/**
 * Lists two factor requirements for the LoggedInUser.
 *
 * SOURCE ListTwoFactorRequirementsRequest @ squareup/multipass/external.proto at 915:1
 */
export const ListTwoFactorRequirementsRequest = $root.lookupType('squareup.multipass.external.ListTwoFactorRequirementsRequest');
fixType(ListTwoFactorRequirementsRequest);
Builder.createAndAttachToType(ListTwoFactorRequirementsRequest);
/**
 * SOURCE ListTwoFactorRequirementsResponse @ squareup/multipass/external.proto at 919:1
 */
export const ListTwoFactorRequirementsResponse = $root.lookupType('squareup.multipass.external.ListTwoFactorRequirementsResponse');
fixType(ListTwoFactorRequirementsResponse);
Builder.createAndAttachToType(ListTwoFactorRequirementsResponse);
/**
 * SOURCE Requirement @ squareup/multipass/external.proto at 920:3
 */
ListTwoFactorRequirementsResponse.Requirement = $root.lookupType('squareup.multipass.external.ListTwoFactorRequirementsResponse.Requirement');
fixType(ListTwoFactorRequirementsResponse.Requirement);
Builder.createAndAttachToType(ListTwoFactorRequirementsResponse.Requirement);
/**
 * Lists recovery details and capabilities for the logged in user.
 *
 * SOURCE ListRecoveryDetailsRequest @ squareup/multipass/external.proto at 939:1
 */
export const ListRecoveryDetailsRequest = $root.lookupType('squareup.multipass.external.ListRecoveryDetailsRequest');
fixType(ListRecoveryDetailsRequest);
Builder.createAndAttachToType(ListRecoveryDetailsRequest);
/**
 * Recovery details and recovery permissions/capabilities for the logged in user.
 *
 * SOURCE ListRecoveryDetailsResponse @ squareup/multipass/external.proto at 945:1
 */
export const ListRecoveryDetailsResponse = $root.lookupType('squareup.multipass.external.ListRecoveryDetailsResponse');
fixType(ListRecoveryDetailsResponse);
Builder.createAndAttachToType(ListRecoveryDetailsResponse);
/**
 * Verifies recovery details for the LoggedInUser.
 *
 * SOURCE VerifyRecoveryDetailRequest @ squareup/multipass/external.proto at 960:1
 */
export const VerifyRecoveryDetailRequest = $root.lookupType('squareup.multipass.external.VerifyRecoveryDetailRequest');
fixType(VerifyRecoveryDetailRequest);
Builder.createAndAttachToType(VerifyRecoveryDetailRequest);
/**
 * SOURCE VerifyRecoveryDetailResponse @ squareup/multipass/external.proto at 982:1
 */
export const VerifyRecoveryDetailResponse = $root.lookupType('squareup.multipass.external.VerifyRecoveryDetailResponse');
fixType(VerifyRecoveryDetailResponse);
Builder.createAndAttachToType(VerifyRecoveryDetailResponse);
/**
 * Lists Launchpad items for the LoggedInUser.
 *
 * SOURCE ListLaunchpadItemsRequest @ squareup/multipass/external.proto at 995:1
 */
export const ListLaunchpadItemsRequest = $root.lookupType('squareup.multipass.external.ListLaunchpadItemsRequest');
fixType(ListLaunchpadItemsRequest);
Builder.createAndAttachToType(ListLaunchpadItemsRequest);
/**
 * SOURCE ListLaunchpadItemsResponse @ squareup/multipass/external.proto at 1003:1
 */
export const ListLaunchpadItemsResponse = $root.lookupType('squareup.multipass.external.ListLaunchpadItemsResponse');
fixType(ListLaunchpadItemsResponse);
Builder.createAndAttachToType(ListLaunchpadItemsResponse);
/**
 * Request to create an exception to the mandatory 2fa flow. Intentionally empty.
 *
 * SOURCE CreateMandatoryTwoFactorExceptionRequest @ squareup/multipass/external.proto at 1014:1
 */
export const CreateMandatoryTwoFactorExceptionRequest = $root.lookupType('squareup.multipass.external.CreateMandatoryTwoFactorExceptionRequest');
fixType(CreateMandatoryTwoFactorExceptionRequest);
Builder.createAndAttachToType(CreateMandatoryTwoFactorExceptionRequest);
/**
 * Response from creating an exception to the mandatory 2fa flow.
 *
 * SOURCE CreateMandatoryTwoFactorExceptionResponse @ squareup/multipass/external.proto at 1025:1
 */
export const CreateMandatoryTwoFactorExceptionResponse = $root.lookupType('squareup.multipass.external.CreateMandatoryTwoFactorExceptionResponse');
fixType(CreateMandatoryTwoFactorExceptionResponse);
Builder.createAndAttachToType(CreateMandatoryTwoFactorExceptionResponse);
/**
 * Request to send a link containing an otp code that navigates the seller to the advanced
 * two factor enrollment flow.
 *
 * SOURCE AdvancedEnrollTwoFactorSendLinkRequest @ squareup/multipass/external.proto at 1034:1
 */
export const AdvancedEnrollTwoFactorSendLinkRequest = $root.lookupType('squareup.multipass.external.AdvancedEnrollTwoFactorSendLinkRequest');
fixType(AdvancedEnrollTwoFactorSendLinkRequest);
Builder.createAndAttachToType(AdvancedEnrollTwoFactorSendLinkRequest);
/**
 * Response containing send code errors.
 *
 * SOURCE AdvancedEnrollTwoFactorSendLinkResponse @ squareup/multipass/external.proto at 1048:1
 */
export const AdvancedEnrollTwoFactorSendLinkResponse = $root.lookupType('squareup.multipass.external.AdvancedEnrollTwoFactorSendLinkResponse');
fixType(AdvancedEnrollTwoFactorSendLinkResponse);
Builder.createAndAttachToType(AdvancedEnrollTwoFactorSendLinkResponse);
/**
 * SOURCE GetGeneralSettingsRequest @ squareup/multipass/external.proto at 1053:1
 */
export const GetGeneralSettingsRequest = $root.lookupType('squareup.multipass.external.GetGeneralSettingsRequest');
fixType(GetGeneralSettingsRequest);
Builder.createAndAttachToType(GetGeneralSettingsRequest);
/**
 * SOURCE GetGeneralSettingsResponse @ squareup/multipass/external.proto at 1058:1
 */
export const GetGeneralSettingsResponse = $root.lookupType('squareup.multipass.external.GetGeneralSettingsResponse');
fixType(GetGeneralSettingsResponse);
Builder.createAndAttachToType(GetGeneralSettingsResponse);
/**
 * Request for a logged in person's two factor promo cohort. Intentionally empty.
 *
 * SOURCE TwoFactorPromoCohortRequest @ squareup/multipass/external.proto at 1064:1
 */
export const TwoFactorPromoCohortRequest = $root.lookupType('squareup.multipass.external.TwoFactorPromoCohortRequest');
fixType(TwoFactorPromoCohortRequest);
Builder.createAndAttachToType(TwoFactorPromoCohortRequest);
/**
 * Response with the seller's two factor promo cohort.
 *
 * SOURCE TwoFactorPromoCohortResponse @ squareup/multipass/external.proto at 1067:1
 */
export const TwoFactorPromoCohortResponse = $root.lookupType('squareup.multipass.external.TwoFactorPromoCohortResponse');
fixType(TwoFactorPromoCohortResponse);
Builder.createAndAttachToType(TwoFactorPromoCohortResponse);
/**
 * SOURCE CheckLoginRequirementsRequest @ squareup/multipass/external.proto at 1072:1
 */
export const CheckLoginRequirementsRequest = $root.lookupType('squareup.multipass.external.CheckLoginRequirementsRequest');
fixType(CheckLoginRequirementsRequest);
Builder.createAndAttachToType(CheckLoginRequirementsRequest);
/**
 * SOURCE AliasInferenceDecision @ squareup/multipass/external.proto at 1114:1
 */
export const AliasInferenceDecision = $root.lookupEnum('squareup.multipass.external.AliasInferenceDecision').values;
/**
 * SOURCE CheckLoginRequirementsResponse @ squareup/multipass/external.proto at 1120:1
 */
export const CheckLoginRequirementsResponse = $root.lookupType('squareup.multipass.external.CheckLoginRequirementsResponse');
fixType(CheckLoginRequirementsResponse);
Builder.createAndAttachToType(CheckLoginRequirementsResponse);
/**
 * SOURCE Step @ squareup/multipass/external.proto at 1121:3
 */
CheckLoginRequirementsResponse.Step = $root.lookupEnum('squareup.multipass.external.CheckLoginRequirementsResponse.Step').values;
/**
 * Manage phone detail messaging status.
 *
 * SOURCE ManagePhoneDetailRequest @ squareup/multipass/external.proto at 1149:1
 */
export const ManagePhoneDetailRequest = $root.lookupType('squareup.multipass.external.ManagePhoneDetailRequest');
fixType(ManagePhoneDetailRequest);
Builder.createAndAttachToType(ManagePhoneDetailRequest);
/**
 * Manage phone detail messaging status.
 *
 * SOURCE ManagePhoneDetailResponse @ squareup/multipass/external.proto at 1158:1
 */
export const ManagePhoneDetailResponse = $root.lookupType('squareup.multipass.external.ManagePhoneDetailResponse');
fixType(ManagePhoneDetailResponse);
Builder.createAndAttachToType(ManagePhoneDetailResponse);
/**
 * SOURCE AcceptInvitationRequest @ squareup/multipass/external.proto at 1167:1
 */
export const AcceptInvitationRequest = $root.lookupType('squareup.multipass.external.AcceptInvitationRequest');
fixType(AcceptInvitationRequest);
Builder.createAndAttachToType(AcceptInvitationRequest);
/**
 * SOURCE AcceptInvitationResponse @ squareup/multipass/external.proto at 1178:1
 */
export const AcceptInvitationResponse = $root.lookupType('squareup.multipass.external.AcceptInvitationResponse');
fixType(AcceptInvitationResponse);
Builder.createAndAttachToType(AcceptInvitationResponse);
/**
 * SOURCE GetPasskeyChallengeRequest @ squareup/multipass/external.proto at 1194:1
 */
export const GetPasskeyChallengeRequest = $root.lookupType('squareup.multipass.external.GetPasskeyChallengeRequest');
fixType(GetPasskeyChallengeRequest);
Builder.createAndAttachToType(GetPasskeyChallengeRequest);
/**
 * SOURCE GetPasskeyChallengeResponse @ squareup/multipass/external.proto at 1198:1
 */
export const GetPasskeyChallengeResponse = $root.lookupType('squareup.multipass.external.GetPasskeyChallengeResponse');
fixType(GetPasskeyChallengeResponse);
Builder.createAndAttachToType(GetPasskeyChallengeResponse);
/**
 * SOURCE ListPasskeysRequest @ squareup/multipass/external.proto at 1211:1
 */
export const ListPasskeysRequest = $root.lookupType('squareup.multipass.external.ListPasskeysRequest');
fixType(ListPasskeysRequest);
Builder.createAndAttachToType(ListPasskeysRequest);
/**
 * SOURCE ListPasskeysResponse @ squareup/multipass/external.proto at 1214:1
 */
export const ListPasskeysResponse = $root.lookupType('squareup.multipass.external.ListPasskeysResponse');
fixType(ListPasskeysResponse);
Builder.createAndAttachToType(ListPasskeysResponse);
/**
 * SOURCE UpdatePasskeyRequest @ squareup/multipass/external.proto at 1224:1
 */
export const UpdatePasskeyRequest = $root.lookupType('squareup.multipass.external.UpdatePasskeyRequest');
fixType(UpdatePasskeyRequest);
Builder.createAndAttachToType(UpdatePasskeyRequest);
/**
 * SOURCE UpdatePasskeyResponse @ squareup/multipass/external.proto at 1232:1
 */
export const UpdatePasskeyResponse = $root.lookupType('squareup.multipass.external.UpdatePasskeyResponse');
fixType(UpdatePasskeyResponse);
Builder.createAndAttachToType(UpdatePasskeyResponse);
/**
 * SOURCE GetObfuscatedAccountInformationRequest @ squareup/multipass/external.proto at 1243:1
 */
export const GetObfuscatedAccountInformationRequest = $root.lookupType('squareup.multipass.external.GetObfuscatedAccountInformationRequest');
fixType(GetObfuscatedAccountInformationRequest);
Builder.createAndAttachToType(GetObfuscatedAccountInformationRequest);
/**
 * SOURCE GetObfuscatedAccountInformationResponse @ squareup/multipass/external.proto at 1246:1
 */
export const GetObfuscatedAccountInformationResponse = $root.lookupType('squareup.multipass.external.GetObfuscatedAccountInformationResponse');
fixType(GetObfuscatedAccountInformationResponse);
Builder.createAndAttachToType(GetObfuscatedAccountInformationResponse);
/**
 * Request to complete the login flow and obtain an unlimited session.
 *
 * SOURCE CompleteLoginRequest @ squareup/multipass/external.proto at 1256:1
 */
export const CompleteLoginRequest = $root.lookupType('squareup.multipass.external.CompleteLoginRequest');
fixType(CompleteLoginRequest);
Builder.createAndAttachToType(CompleteLoginRequest);
/**
 * Response from completing the login flow and obtaining an unlimited session.
 *
 * SOURCE CompleteLoginResponse @ squareup/multipass/external.proto at 1263:1
 */
export const CompleteLoginResponse = $root.lookupType('squareup.multipass.external.CompleteLoginResponse');
fixType(CompleteLoginResponse);
Builder.createAndAttachToType(CompleteLoginResponse);
/**
 * ------------- SERVICES ------------- //
 * This interface is used by front-ends that deal directly with client devices.
 *
 * SOURCE MultipassExternalService @ squareup/multipass/external.proto at 1271:1
 */
export const MultipassExternalService = $root.lookupService('squareup.multipass.external.MultipassExternalService');